import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

export const trackAccountFlowDropOff = ({
  step,
  scenario = '',
  couponCode = '',
  planDuration = null,
  entryPoint = '',
  timeSpentSeconds = 0,
}) => {
  const properties = {
    step: step,
    scenario: scenario,
    coupon_code: couponCode,
    plan_duration: planDuration,
    entry_point: entryPoint,
    time_spent_seconds: timeSpentSeconds,
  }
  ga.track('account_flow_drop_off', properties)
  // FLAG: time_spent_seconds has no standardized property; kept in GA only.
  amplitude.track('user_cancel_onboarding', {
    ...baseWebEventProps(),
    action_name: 'cancel',
    action_type: 'active',
    funnel_step: step,
    funnel_type: scenario,
    ...(entryPoint ? { event_source: entryPoint } : {}),
    coupon: couponCode,
  })
}
